import YouTubeGrid from '../components/YouTubeGrid';

export default function VideosPage() {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0c0c15] to-[#18181b] flex flex-col">
      {/* Hero Section */}
      <section className="w-full py-16 px-4 bg-gradient-to-br from-[#0a1014] to-[#10151a] flex flex-col items-center text-center">
        <picture>
          <source srcSet="/images/branding/SOLANA-VOLUME-BOT-MASCOTTE.avif" type="image/avif" />
          <source srcSet="/images/branding/SOLANA-VOLUME-BOT-MASCOTTE.webp" type="image/webp" />
          <img src="/images/branding/SOLANA-VOLUME-BOT-MASCOTTE.svg" alt="Solana Volume Bot Mascot, branding illustration" className="w-20 h-20 mb-4 rounded-full shadow-lg bg-black/10" loading="lazy" />
        </picture>
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 drop-shadow-lg">Solana Volume Bot Videos</h1>
        <p className="text-lg md:text-xl text-gray-300 max-w-2xl mb-2">Explore our latest tutorials, feature walkthroughs, and community highlights. Stay up to date and learn how to get the most out of Solana Volume Bot!</p>
      </section>
      {/* Videos Grid Section */}
      <section className="container mx-auto px-4 py-12 flex-1">
        <YouTubeGrid />
      </section>
    </div>
  );
} 